import React from "react";
import { CollectionAsset } from "src/types/collections";

export interface ShareRecipient{
  firstName: string,
  lastName: string,
  company: string,
  email: string,
  sharedDate: number,
}
interface CollectionContextProps {
  id?: string;
  entityType: string;
  itemSelector: string;
  editSelector: string;
  updateSelector: string;
  recipientSelector: string;

  // eslint-disable-next-line no-unused-vars
  fetchSection: (section: string) => void,

  // eslint-disable-next-line no-unused-vars
  onSectionClick: (section: number) => void;

  // eslint-disable-next-line no-unused-vars
  createSection: (id: string, name: string) => void;

  // eslint-disable-next-line no-unused-vars
  removeSection: (section: number) => void;

  // eslint-disable-next-line no-unused-vars
  renameSection: (section: number, name: string) => void;

  // eslint-disable-next-line no-unused-vars
  moveSection: (section: number, direction: number) => void;

  // eslint-disable-next-line no-unused-vars
  removeAsset: (section: number | null, asset: string) => void;
  
  // eslint-disable-next-line no-unused-vars
  onAssetClick?: (section: number, asset: string) => void;
  
  // eslint-disable-next-line no-unused-vars
  moveAsset: (section: number | null, from: number, to: number) => void;

  // eslint-disable-next-line no-unused-vars
  moveAssetToSection: (source: number, target: number, asset: CollectionAsset) => void;

  // eslint-disable-next-line no-unused-vars
  updateAssetMetadata: (section: number | null | undefined, updates: {id: string;metadata: any;}[]) => void; 

  // eslint-disable-next-line no-unused-vars
  updateCollectionProperty: (property: string, value: any) => void;

  // eslint-disable-next-line no-unused-vars
  getRecipient: (recipient) => ShareRecipient | null;

  // eslint-disable-next-line no-unused-vars
  fetchRecipientsForPage: (page) => void;

  getNotificationContent: () => {subject: string, message: string}
}

export const CollectionContext = React.createContext<CollectionContextProps>({
  entityType: "",
  itemSelector: "",
  editSelector: "",
  updateSelector: "",
  recipientSelector: "",
  fetchSection: () => {},
  onSectionClick: () => {},
  createSection: () => {},
  removeSection: () => {},
  renameSection: () => {},
  moveSection: () => {},
  removeAsset: () => {},
  moveAsset: () => {},
  moveAssetToSection: () => {},
  updateAssetMetadata: () => {},
  updateCollectionProperty: () => {},
  getRecipient: () => null,
  fetchRecipientsForPage: () => {},
  getNotificationContent() {
    return {
      subject: "",
      message: "",
    }
  },
});